class Footer {
  constructor() {
    this.footer = document.querySelector('footer')

    if (!this.footer) {
      return
    }

    // this.render()
  }

  render() {
    this.addFooterClasses()
  }

  addFooterClasses() {
    this.footer.classList.add('footer')
    this.footer.querySelector('.links').classList.add('footer-bottom')
    this.footer.querySelector('.links > div:not(.flex-fill)').classList.add('nav', 'justify-content-center')
    this.footer.querySelectorAll('.links a').forEach((link) => link.classList.add('nav-link'))
  }
}

export default Footer
